<template>

  <div>

    <t-dialog-form :generalErrors="generalErrors" title="Detalhes da Foto" ok-text="Continuar"
                   :id="modalEvidenceFileId" :command="'insert'"
                   ref="dialog_form" @onSubmit="onEvidenceContinue">

      <t-input v-model="form.typeEvidenceCategoryId" label="Categoria" select
               :options="typeEvidenceCategoryOptions"
               v-show="businessEvidenceFileRequiredFieldsObject.categoryShow"
               :required="businessEvidenceFileRequiredFieldsObject.categoryRequired"/>

      <b-row>

        <b-col cols="12" v-show="businessEvidenceFileRequiredFieldsObject.serviceShow">

          <div class="d-flex" style="justify-content: space-between">

            <div>Serviço<span v-show="businessEvidenceFileRequiredFieldsObject.serviceRequired">*</span></div>

            <b-form-checkbox v-model="form.typeEvidenceServiceNotFound" switch>

              <small>Outro?</small>

            </b-form-checkbox>

          </div>

          <t-input v-show="!form.typeEvidenceServiceNotFound"
                   v-model="form.typeEvidenceServiceId"
                   hide-label label="Serviço" select :options="typeEvidenceServiceOptions"
                   :required="!form.typeEvidenceServiceNotFound && businessEvidenceFileRequiredFieldsObject.serviceRequired"/>


          <t-input v-show="form.typeEvidenceServiceNotFound"
                   v-model="form.typeEvidenceServiceNotFoundOther"
                   hide-label label="Serviço - Outro" placeholder="Informe o serviço desejado"
                   :required="form.typeEvidenceServiceNotFound && businessEvidenceFileRequiredFieldsObject.serviceRequired"/>


        </b-col>

      </b-row>

      <t-input v-show="businessEvidenceFileRequiredFieldsObject.statusShow"
               v-model="form.typeEvidenceStatusId" label="Status" select
               :options="typeEvidenceStatusOptions"
               :required="businessEvidenceFileRequiredFieldsObject.statusRequired"/>

      <t-input
          v-show="businessEvidenceFileRequiredFieldsObject.complementShow"
          v-model="form.environmentComplement" :required="businessEvidenceFileRequiredFieldsObject.complementRequired"
          help="Utilize para acrescentar alguma informação de identificação deste ambiente. Exemplo: Próximo as escadas ou 1º Andar."
          label="Complemento do Ambiente"/>

      <t-input v-model="form.fileEntity.subtitle"
               :required="businessEvidenceFileRequiredFields === 'Y'"
               enable-optimize-ai
               textarea label="Observações"
      />

    </t-dialog-form>

    <t-page-form-upload
        :type-image="typeImage"
        :command="command"
        :other-entity="otherEntity"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.checklistEnvironmentEvidenceFileId" :foreign-key="form.checklistEnvironmentId"
        :business-evidence-file-required-fields="businessEvidenceFileRequiredFields"
        :business-evidence-file-label-order-fields="businessEvidenceFileLabelOrderFields"
        :items="items" :user-auth="userAuth" :status="status"
        :subtitle="form.fileEntity.subtitle"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :enabled-table-images-details="enabledTableImagesDetails"
        special-type-evidence-file
        :message-not-record="messageNotRecord"
        :only-view="onlyView"
        :continued-submit="continuedSubmit"
        :evidence-file-entity="form"
        enable-public
        @onSubmit="onSubmit"
        @itemDownload="onItemFileDownload"
        @onItemDelete="onItemDeleteDefault"
        @onSpecialTypeEvidenceFileOpenDialog="onSpecialTypeEvidenceFileOpenDialog"
        @onUploadComplete="onUploadComplete" @onRequestList="getList">

      <template #before-subtitle="{item}">
        <div class="border-bottom mb-2 pb-2"
             v-show="objValid(item.typeEvidenceCategory) || objValid(item.typeEvidenceServiceAutomatically) || objValid(item.typeEvidenceStatus)">

          <div v-show="objValid(item.typeEvidenceCategory)">{{ item.typeEvidenceCategory }}</div>
          <div v-show="objValid(item.typeEvidenceServiceAutomatically)"><small>{{
              item.typeEvidenceServiceAutomatically
            }}</small></div>

          <span
              v-show="objValid(item.typeEvidenceStatus)"
              class="badge badge-light"
              :style="{'background-color': item.typeEvidenceStatusBackgroundColor,'color': item.typeEvidenceStatusTextColor}">{{
              item.typeEvidenceStatus
            }}</span>

        </div>

      </template>

    </t-page-form-upload>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormUploadMixin from "@/mixins/page/pageFormUploadMixin";
import tPageFormUpload from "@/components/template/page/t-page-form-upload";
import tDialogForm from "@/components/template/dialog/t-dialog-form.vue";
import TypeEvidenceCategoryService from "@/services/modules/checklist/TypeEvidenceCategory.service";
import TypeEvidenceServiceService from "@/services/modules/checklist/TypeEvidenceService.service";
import TypeEvidenceStatusService from "@/services/modules/checklist/TypeEvidenceStatus.service";
import ui from "@/assets/scripts/ui";
import checklistService from "@/services/modules/checklist/Checklist.service";
import BusinessEvidenceFileEntity from "@/model/entities/modules/checklist/BusinessEvidenceFileEntity";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormUploadMixin],
  components: {tPageFormUpload, tDialogForm},
  name: 'ChecklistEnvironmentEvidenceFile',
  data() {
    return {
      path: "checklist/environment-evidence-file", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "checklistEnvironmentEvidenceFileId",
      foreignKeyColumn: "checklistEnvironmentId", //Utilizar quando usar Tabs com outros componentes
      type: "D", //Tipo padrão de modelo de envio de arquivos poderá ser I ou D
      form: {
        checklistEnvironmentId: this.foreignKey,
        checklistEnvironmentEvidenceFileId: 0,
        orderList: 0,
        type: "I",
        typeEvidenceCategoryId: 0,
        typeEvidenceServiceId: 0,
        typeEvidenceServiceNotFound: false,
        typeEvidenceServiceNotFoundOther: "",
        typeEvidenceStatusId: 0,
        environmentComplement: "",
        fileEntity: {
          nameOriginal: "",
          nameSave: "",
          subtitle: "",
          sizeKb: 0,
          extension: "",
        }
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
        "typeEvidenceCategoryId",
        "typeEvidenceServiceId",
        "typeEvidenceServiceNotFound",
        "typeEvidenceServiceNotFoundOther",
        "typeEvidenceStatusId",
        "environmentComplement",
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      continuedSubmit: false,
      typeEvidenceCategoryOptions: [],
      typeEvidenceServiceOptions: [],
      typeEvidenceStatusOptions: [],
      modalEvidenceFileId: "modal-evidence-file-information-" + ui.generateRandomNumber(100000, 999999),
      businessEvidenceFileRequiredFieldsObject: new BusinessEvidenceFileEntity(),
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    checklistId: Number,
    otherEntity: Boolean,
    typeOld: Boolean, //Evidências sincronizadas anteriormente deste mesmo ambiente.
    businessEvidenceFileRequiredFields: {
      required: true,
      type: String,
      default: 'N',
    },
    businessEvidenceFileLabelOrderFields: {
      required: true,
      type: String,
      default: '',
    },
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      if (this.otherEntity) {
        this.command = 'view'
      }

      this.mountedPrepareFormUploadDefault()

    },

    async mountedContinued() {

      this.listParams.append("typeOld", "" + this.typeOld)

      await this.getList()

      await TypeEvidenceCategoryService.selectList("").then((list) => {
        this.typeEvidenceCategoryOptions = list
      }).catch(error => this.responseError(error))

      await TypeEvidenceServiceService.selectList("").then((list) => {
        this.typeEvidenceServiceOptions = list
      }).catch(error => this.responseError(error))

      await TypeEvidenceStatusService.selectList("").then((list) => {
        this.typeEvidenceStatusOptions = list
      }).catch(error => this.responseError(error))

      this.businessEvidenceFileRequiredFieldsObject = checklistService.onBusinessEvidenceFileRequiredFieldsFromString(this.businessEvidenceFileRequiredFields)


    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.checklistEnvironmentEvidenceFileId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //REPLICAR EM TypeChecklistModelForm e ChecklistEnvironmentEvidenceFile

    //------------------------------------------------

    onSpecialTypeEvidenceFileOpenDialog() {

      this.continuedSubmit = false

      if (this.businessEvidenceFileRequiredFields === 'N') {
        //Não deverá abrir o dialogo por padrão, exceto se o usuário clicar na foto, porém irá inserir a legenda neste caso

        setTimeout(()=>{
          this.onEvidenceContinue()
        },200)

      } else {
        //Deverá abrir o dialogo, pois neste caso é obrigatório
        this.openModal(this.modalEvidenceFileId)
      }

    },

    onEvidenceContinue() {
      this.$bvModal.hide(this.modalEvidenceFileId)
      this.continuedSubmit = true
    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
